/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientInput } from './PatientInput';
import {
    PatientInputFromJSON,
    PatientInputFromJSONTyped,
    PatientInputToJSON,
} from './PatientInput';

/**
 * 
 * @export
 * @interface StartExecutionRequest
 */
export interface StartExecutionRequest {
    /**
     * Facility ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    facilityId: string;
    /**
     * 
     * @type {PatientInput}
     * @memberof StartExecutionRequest
     */
    taskBody: PatientInput;
}

/**
 * Check if a given object implements the StartExecutionRequest interface.
 */
export function instanceOfStartExecutionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facilityId" in value;
    isInstance = isInstance && "taskBody" in value;

    return isInstance;
}

export function StartExecutionRequestFromJSON(json: any): StartExecutionRequest {
    return StartExecutionRequestFromJSONTyped(json, false);
}

export function StartExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecutionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facilityId': json['facilityId'],
        'taskBody': PatientInputFromJSON(json['taskBody']),
    };
}

export function StartExecutionRequestToJSON(value?: StartExecutionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facilityId': value.facilityId,
        'taskBody': PatientInputToJSON(value.taskBody),
    };
}

